// Front-end only — no back-end counterpart.

export type NavMenuSection = 'main' | 'secondary' | 'user'

export const NavMenuSection = {
  MAIN: 'main',
  SECONDARY: 'secondary',
  USER: 'user'
} satisfies Record<string, NavMenuSection>

export const NavMenuSectionValues: readonly NavMenuSection[] = Object.values(NavMenuSection)
